export default __webpack_public_path__ + "static/media/c1.74fe9a0f.png";